import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';

import { Columns, Column, MuiTitle } from 'src/ui/mui-ui-kit';;
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import {
  setBreadcrumbs,
  reduceServerErrors,
  ConfirmDeletionModal,
  UiToastAdapter,
  GuidelinesCard,
} from 'src/ui';
import { getToken } from 'src/auth';
import { getUser } from 'src/user';
import { getAccount, fetchAccount, deleteAccountLoan } from 'src/account';
import { LoansTable } from '../components';

class LoansListPage extends Component {
  _isMounted = false;

  state = {
    loading: true,
    deletingLoan: null,
  };

  guidelines = [`Use this form to fill out loan request information.`];

  async componentDidMount() {
    this._isMounted = true;
    const { setBreadcrumbs, fetchAccount, token } = this.props;

    setBreadcrumbs([{ label: 'Loans', href: '/loans' }]);

    if (token.isValid()) {
      const { user } = this.props;

      if (user.accountId) {
        await fetchAccount(user.accountId);

        const { account } = this.props;
        if (account.isError()) {
          reduceServerErrors(account);
        }
      }
    }
    if (this._isMounted) {
      this.setState({ loading: false });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  onDeleteLoan = loan => {
    this.setState({ deletingLoan: loan });
  };

  onCancelDeleteLoan = () => {
    this.setState({ deletingLoan: null });
  };

  onConfirmDeleteLoan = async () => {
    const { user, deleteAccountLoan } = this.props;
    const { deletingLoan } = this.state;

    this.setState({ loading: true });
    this.onCancelDeleteLoan();

    await deleteAccountLoan({
      accountId: user.accountId,
      loanId: deletingLoan.id,
    });

    this.setState({ loading: false });

    const { account } = this.props;
    if (account.isError()) {
      return reduceServerErrors(account);
    }
    toast(UiToastAdapter('Loan deleted successfully!', 'success'));
    return undefined;
  };

  render() {
    const { account, user } = this.props;
    const { loading, deletingLoan } = this.state;

    return (
      <>
        <Columns isMultiline>
          <Column isSize="1/2">
            <MuiTitle isSize="4" hasTextColor="info" tag="h2">
              Loans
            </MuiTitle>
          </Column>
          <Column isSize="1/2">
            <NavLink
              className="button is-gradient-bright is-long is-pulled-right"
              to="/loans/add"
            >
              <span className="icon is-left">
                <FontAwesomeIcon icon={['fal', 'plus']} />
              </span>
              <span>Add Loan</span>
            </NavLink>
          </Column>
          <Column>
            <LoansTable
              loading={loading}
              loans={account.loans || []}
              onDeleteLoan={this.onDeleteLoan}
            />
          </Column>
          {!user.isBankAdmin && !user.isSuperAdmin && (
            <Column isSize="narrow">
              <GuidelinesCard guidelines={this.guidelines} />
            </Column>
          )}
        </Columns>
        <ConfirmDeletionModal
          isActive={!!deletingLoan}
          onClickCancel={this.onCancelDeleteLoan}
          onClickConfirm={this.onConfirmDeleteLoan}
          title={`Loan ${(deletingLoan || {}).loanIdentifier ||
            (deletingLoan || {}).id} - ${(deletingLoan || {}).loanType}`}
        />
      </>
    );
  }
}

LoansListPage.propTypes = {
  fetchAccount: propTypes.func.isRequired,
  setBreadcrumbs: propTypes.func.isRequired,
  deleteAccountLoan: propTypes.func.isRequired,
  token: propTypes.object.isRequired,
  user: propTypes.object.isRequired,
  account: propTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    token: getToken(state),
    user: getUser(state),
    account: getAccount(state),
  };
}

const connectedLoansListPage = connect(mapStateToProps, {
  fetchAccount,
  setBreadcrumbs,
  deleteAccountLoan,
})(LoansListPage);

export { connectedLoansListPage as LoansListPage };